// extracted by mini-css-extract-plugin
export default {"community":"styles_community__BPbkh","tags":"styles_tags__o8Gx5","communityStatus":"styles_communityStatus__Ltl5e","content":"styles_content__Q4wQK","same":"styles_same__zS94S"};